import React from "react";

/**
 * Loading Spinner Component
 * 
 * A reusable loading component following SOLID principles:
 * - Single Responsibility: Only handles loading state display
 * - Open/Closed: Easy to extend with different loading styles
 */
export const LoadingSpinner: React.FC = () => (
  <div className="flex items-center justify-center min-h-screen bg-ds-dark">
    <div className="flex flex-col items-center gap-4">
      <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-ds-accent"></div>
      <p className="text-ds-text text-sm">Loading...</p>
    </div>
  </div>
);
